import {
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
  ScmAuth,
} from '@backstage/integration-react';
import {
  AnyApiFactory,
  BackstageIdentityApi,
  OAuthApi,
  OpenIdConnectApi,
  ProfileInfoApi,
  SessionApi,
  alertApiRef,
  configApiRef,
  createApiFactory,
  createApiRef,
  discoveryApiRef,
  oauthRequestApiRef,
} from '@backstage/core-plugin-api';
import { OAuth2 } from '@backstage/core-app-api';
import { toastApiRef } from '@backstage/frontend-plugin-api';

export const dexAuthApiRef = createApiRef<
  OAuthApi & OpenIdConnectApi & ProfileInfoApi & BackstageIdentityApi & SessionApi
>({ id: 'auth.oidc.default' });

export const apis: AnyApiFactory[] = [
  createApiFactory({
    api: scmIntegrationsApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
  }),
  ScmAuth.createDefaultApiFactory(),
  createApiFactory({
    api: toastApiRef,
    deps: { alertApi: alertApiRef },
    factory: ({ alertApi }) => ({
      post(toast) {
        const severityMap: Record<string, 'success' | 'info' | 'warning' | 'error'> = {
          success: 'success',
          info: 'info',
          warning: 'warning',
          danger: 'error',
          neutral: 'info',
        };
        alertApi.post({
          message: String(toast.title),
          severity: severityMap[toast.status ?? 'success'] ?? 'info',
          display: 'transient',
        });
        return { close: () => {} };
      },
    }),
  }),
  createApiFactory({
    api: dexAuthApiRef,
    deps: {
      discoveryApi: discoveryApiRef,
      oauthRequestApi: oauthRequestApiRef,
      configApi: configApiRef,
    },
    factory: ({ discoveryApi, oauthRequestApi, configApi }) =>
      OAuth2.create({
        discoveryApi,
        oauthRequestApi,
        environment: configApi.getOptionalString('auth.environment'),
        provider: {
          id: 'oidc',
          title: 'Dex',
          icon: () => null,
        },
        defaultScopes: ['openid', 'profile', 'email', 'offline_access'],
      }),
  }),
];
